module.exports = __webpack_public_path__ + "static/media/lv.e8e84bf0.svg";